// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Banner,
  Box,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { ModalConfirm } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { lightGrey } from '@fortress-technology-solutions/fortress-component-library/design';
import { formatDateDisplayUTC } from '@fortress-technology-solutions/fortress-component-library/utils/index';
import confirmMessages from '../../../components/ConfirmDialogModal/messages';
import messages from './messages';

type DeleteGrossRentChangeModalProps = {
  effectiveDate: string,
  isSubmitting?: boolean,
  onCancel: () => void,
  onConfirm: () => void,
  open: boolean,
};

const DeleteGrossRentChangeModal = ({
  effectiveDate,
  isSubmitting = false,
  onCancel,
  onConfirm,
  open,
}: DeleteGrossRentChangeModalProps) => {
  const formattedEffectiveDate = formatDateDisplayUTC(
    effectiveDate,
    'MM/DD/YYYY',
  );

  return (
    <ModalConfirm
      open={open}
      onClose={onCancel}
      title={<FormattedMessage {...messages.deleteGrossRentChangeModalTitle} />}
      TitleProps={{
        sx: (theme) => ({
          ...theme.typography.titleLarge,
        }),
      }}
      actionsProps={[
        {
          children: <FormattedMessage {...confirmMessages.cancel} />,
          onClick: onCancel,
          variant: 'text',
        },
        {
          children: <FormattedMessage {...confirmMessages.confirm} />,
          onClick: onConfirm,
          submitButton: true,
          isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      ContentProps={{
        sx: {
          maxWidth: 565,
        },
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="bodyMedium" color={lightGrey.dark} display="block">
          <FormattedMessage
            {...messages.deleteGrossRentChangeModalBodyIntro}
            values={{ effectiveDate: formattedEffectiveDate }}
          />
        </Typography>
        <Banner
          status="warning"
          title={
            <FormattedMessage
              {...messages.deleteGrossRentChangeWarningBannerTitle}
            />
          }
          message={
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
              <li>
                <FormattedMessage
                  {...messages.deleteGrossRentChangeWarningBannerBulletFloorPlans}
                />
              </li>
              <li>
                <FormattedMessage
                  {...messages.deleteGrossRentChangeWarningBannerBulletCertifications}
                />
              </li>
            </Box>
          }
        />
      </Stack>
    </ModalConfirm>
  );
};

export default DeleteGrossRentChangeModal;
